import { Hourglass } from "@attaditya/iconoir-preact";
import { LinkButton } from "@components/ui/interactive/link-button";
import { Container } from "@components/ui/structure/container";
import { Image } from "@components/ui/structure/image";
import { Heading } from "@components/ui/text/heading";
import { Text } from "@components/ui/text/text";
import { useChat } from "@contexts/chat";
import { useClasses } from "@styles";

export function Sidebar() {
  const { ready, chats } = useChat();

  return (<>
    <Container className={useClasses("sidebar")}>
      <Container className={useClasses("sidebar-container")}>
        <Container className={useClasses("sidebar-header")}>
          <Image
            src="/logo.png"
            alt="Logo"
            className={useClasses("sidebar-header-logo")}
          />

          <Heading
            size="medium"
            className={useClasses("sidebar-heading")}
          >
            AutoQuery
          </Heading>
        </Container>

        <Container className={useClasses("sidebar-content")}>
          <LinkButton
            url="/"
            icon="TestTubeRegular"
            title="New Analysis"
            urlText="Start a new analysis"
            newTab={false}
          />

          <Heading
            className={useClasses("sidebar-recent-heading")}
            size="small"
          >
            Recent Analysis
            {!ready && (<Hourglass
              className={useClasses('sidebar-loading-icon')}
            />)}
          </Heading>

          <Container className={useClasses("sidebar-recent-list")}>
            {ready && chats.length === 0 && (
              <Text className={useClasses("sidebar-recent-empty")}>
                No analysis yet, start a new one to see it here!
              </Text>
            )}

            {!ready && (
              <Text className={useClasses("sidebar-recent-empty")}>
                Loading...
              </Text>
            )}

            {chats.map((chat) => (
              <LinkButton
                key={chat.uuid}
                url={`/report/${chat.uuid}`}
                icon="PageRegular"
                title={chat.name}
                urlText="Check analysis"
                newTab={false}
              />
            ))}
          </Container>
        </Container>
      </Container>
    </Container>
  </>);
}

